import axios from 'axios'
import { TrainingProgressType } from 'queries/types/progress'
import { UserType } from 'queries/types/user'

const setProgressQuery = async (data: Partial<UserType['progress']> & { token: string }) =>
  await axios.patch<TrainingProgressType>('/api/progress', data)

export { setProgressQuery }
